<template>
  <div><transation-detail-component /></div>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>